import type { Axios } from 'axios';
import { get, writable } from 'svelte/store';
import { apiStore } from './api';
import { DateTime } from 'luxon';

export type SmsRefill = {
	id: number;
	creditAmount: number;
	createdAt: DateTime;
	status: string;
	type: string;
	hash: string | null;
};

export type SmsRefillApi = Omit<SmsRefill, 'createdAt'> & {
	createdAt: string;
};

export const smsRefillStore = writable<SmsRefill[]>([]);

export function loadSmsRefills() {
	(get(apiStore) as Axios).get<SmsRefillApi[]>('/business/sms-settings/refills').then((res) => {
		loadSmsRefillsFromData(res.data);
	});
}

function loadSmsRefillsFromData(data: SmsRefillApi[]) {
	smsRefillStore.set(
		data.map((refill) => {
			return {
				...refill,
				createdAt: DateTime.fromISO(refill.createdAt)
			};
		})
	);
}
